import { SliceCaseReducers } from '@reduxjs/toolkit'
import { CashMovementDetailParams, CashMovementDetailResponse } from '@repo/accounts-types'
import { createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<CashMovementDetailResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: cashMovementDetailDataActions, reducer: cashMovementDetailDataReducer } =
  createOperationSlice<
    CashMovementDetailResponse | null,
    SliceCaseReducers<GenericOperationState<CashMovementDetailResponse | null>>,
    CashMovementDetailParams
  >({
    name: '@accounts/detail/read/cashMovement/detail',
    initialState,
    reducers: {},
  })
